import React, { Fragment, Suspense, lazy } from "react";
import { withStyles } from "@material-ui/core";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import ShipmentGridConfig from "./ShipmentsGridConfig";
import RouteConfirmationModal from "./RouteConfirmationModal";
import DataGrid from "../../../dataGrid/index";
import { observer, inject } from "mobx-react";
import { autorun } from "mobx";
import appConstant from "../../../../appConstants";
import MESSAGES from "../../../../appMessages";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { addMinutes, isValid as isDateTimeValid, format, subMinutes } from "date-fns";
import { postData } from "../../../../api/componentAPIs";
import { isEqual } from "lodash/lang";
import StatusBar from "../../../dataGrid/StatusBar";
import { AppLoading } from "../../../../loaders/loaders";
import CheckViolation from "../../../common/checkViolation";
import GeocodingModal from "../../Common/Geocoding/GeoCodingModal";
import { getShipmentCustomerData } from "../../Common/Geocoding/utils";
import { trackEvent } from "../../../common/AppInsightsEventTracking";
import { withAppConfig } from "../../../../appConfigContext";
import { withFeatureFlags } from "../../../../userProfile/featureFlagsContext";
import { getSpecialNeeds } from "../../utils";
import Events from "../../../../utilities/EventEmitter";
import Dialog from "../../../common/Dialog";
import { REVERT_COLUMNS, REVERT_COLUMN_CONFIG } from "./constant";
const ShipmentNote = lazy(() => import("./ShipmentNote"));

const ViewProImages = lazy(() => import("../Common/ViewProImages"));

const styles = (theme) => ({
  highlightText: {
    color: theme.HeaderSelectedText,
  },
});
@inject("IBPlanningStore")
@observer
class ShipmentsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new ShipmentGridConfig({
      userConfig: this.props.userData.userProfile?.columnPref,
      featureFlags:{ 
        IsWeightBasedRoutingEnabled: this.props.featureFlags.isFeatureEnabled(appConstant.features.isWeightBasedRouting),
        isFFEConfig: this.props.configJSON?.showDateRangeInShipmentSelection || false,
      },
      terminalAccessLabel: this.props.configJSON.terminalAccessLabel,
      ROUTENAME_EDITOR_PARAMS: this.props.configJSON?.routeNameEditParams,
      columnConfig: this.props.configJSON?.gridColumnConfig,
    });
    this.selectedShipmentProIdList = [];
    this.isAnyFilterSet = false;
    this.state = {
      quickFilterText: "",
      showProImagesPopup: false,
      shipmentNoteDialogParams: null,
      proIdList: [],
      filterData: "",
      geocodeShipment: null,
      isRouteConfirmModalVisible: false,
      revertPros:[],
      revertProInProgress: false,
      setAPTWindowPros:[],
      setProAPTInProgress:false
    };
    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.isRoutesView = false;
    const glContainer = this.props.glContainer;
    if (glContainer && glContainer._config && glContainer._config.location) {
      this.isRoutesView = glContainer._config.location.includes("routes");
    }
    this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
    this.gridContext = {
      newShipments: this.props.IBPlanningStore.newShipments,
      hasProImagesURL: this.hasProImagesURL(),
      specialNeedsOptions: getSpecialNeeds(this.serviceLevelList),
    };
    this.gridApi = {};
    this.datarefreshed = true;
    this.shipmentRevertFieldsUpdated = false;
    this.revertField = null;
  }

  componentDidMount() {
    this.autorunDispose = autorun(() => {
      if (
        !isEqual(
          this.selectedShipmentProIdList,
          this.props.IBPlanningStore.selectedShipmentIDList
        )
      ) {
        this.selectShipments(
          this.props.IBPlanningStore.selectedShipmentIDList,
          !this.datarefreshed
        );
      }
      if (this.isRoutesView) {
        const { selectedRouteNameList, routesList } =
          this.props.IBPlanningStore;
        if (selectedRouteNameList.length > 0) {
          const plannedRoutesCount = routesList.filter(
            (route) =>
              selectedRouteNameList.includes(route.routeName) &&
              route.routeName != appConstant.UNRTD_ROUTENAME &&
              !route.isTrapRoute
          ).length;
          if (plannedRoutesCount === 0) {
            this.props.glEventHub.emit(
              `${this.gridHeaderId}_activateTab`,
              this.props.glContainer._config.id
            );
          }
        }
      }
    });

    this.autorunPriorityShipmentList = autorun(() => {
      if (
        !isEqual(
          this.serviceLevelList,
          this.props.IBPlanningStore.serviceLevelList
        )
      ) {
        this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
        this.gridContext = {
          newShipments: this.props.IBPlanningStore.newShipments,
          hasProImagesURL: this.hasProImagesURL(),
          specialNeedsOptions: getSpecialNeeds(this.serviceLevelList),
        };
      }
    });

    this.autorunNewShipmentsDispose = autorun(() => {
      if (
        this.props.IBPlanningStore.newShipments.data &&
        this.props.IBPlanningStore.newShipments.data.slice()
      ) {
        this.refreshViolationColumn();
      }
    });

    this.autorunShipmentRefreshed = autorun(() => {
      if (this.props.IBPlanningStore.shipmentsList.slice()) {
        this.datarefreshed = true;
      }
    });

    this.props.glEventHub.on(
      appConstant.Event.SHIPMENT_SELECTED_MAP,
      this.onShipmentSelectedOnMap
    );
    this.props.glEventHub.on(`${this.gridHeaderId}`, this.onSearchTextChanged);
    this.props.glEventHub.on(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_ShowShipmentNote`,
      this.onClickShipmentNote
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_geocode`,
      this.geocodeSelectedShipments
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_revertData`,
      this.revertColumnData
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_setAPTWindow`,
      this.setAPTWindow
    );
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      appConstant.Event.SHIPMENT_SELECTED_MAP,
      this.onShipmentSelectedOnMap
    );
    this.props.glEventHub.off(`${this.gridHeaderId}`, this.onSearchTextChanged);
    this.props.glEventHub.off(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_ShowShipmentNote`,
      this.onClickShipmentNote
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_geocode`,
      this.geocodeSelectedShipments
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_revertData`,
      this.revertColumnData
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_setAPTWindow`,
      this.setAPTWindow
    );
    this.autorunDispose && this.autorunDispose();
    this.autorunNewShipmentsDispose && this.autorunNewShipmentsDispose();
    this.autorunShipmentRefreshed && this.autorunShipmentRefreshed();
    this.autorunPriorityShipmentList && this.autorunPriorityShipmentList();
  }

  hasProImagesURL = () => {
    return Boolean(this.props.configJSON.proImagesUrl);
  }
  
  runCommand = (command, data) => {
    /* once Latitude/Longitude get updated using geocoding popup in grid, we need to show updated marker in geocoding popup map */
    let selectedShipment;
    if (command === "openGeoCodeModel") {
      if (this.isRoutesView) { 
        selectedShipment = this.props.IBPlanningStore.filteredRouteShipments.find(
          (routesShipment) => data.proId === routesShipment.proId,
        );
      } else {
        selectedShipment = this.props.IBPlanningStore.filteredShipments.find(
          (shipment) => data.proId === shipment.proId,
        );
      }
      this.setState({
        geocodeShipment: getShipmentCustomerData(selectedShipment),
      });
    } else if(command === "revert"){
      this.revertColumnData(data.field);      
    }
  };
  revertColumnData = (field) => {
   const fieldConfig = REVERT_COLUMN_CONFIG[field];
   const selectedPros =  this.gridApi.getSelectedRows();
   if(!selectedPros.length){
    this.props.enqueueSnackbar(fieldConfig.noProSelectedErrorMessage, { variant: 'error' });
   }

   const revertData = selectedPros.reduce((revertData,data) => {
        if(data[fieldConfig.isModifiedField]){
          revertData.proNumbers.push(data.proId)
        } else {
          revertData.nonupdatedPro++;
        }
        return revertData
    },{
      proNumbers:[],
      nonupdatedPro:0
    })
    if(revertData.nonupdatedPro > 0){
      this.props.enqueueSnackbar(fieldConfig.noProSelectedErrorMessage, { variant: 'error' });
    } else {
      this.revertField = field;
      this.setState({
        revertPros: revertData.proNumbers,
      })
    }
  }

  setAPTWindow = () => {
    const selectedPros = this.gridApi.getSelectedRows();
    if (!selectedPros.length) {
      this.props.enqueueSnackbar(
        MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED_SET_APT,
        { variant: "error" }
      );
      return;
    }
    const prosToUpdate = selectedPros.filter((pro) => pro.deliveryDateTime && !pro.shipmentCTA);
    if (prosToUpdate.length > 0) {
      this.setState({
        setAPTWindowPros: prosToUpdate
      })
    } else {
      this.props.enqueueSnackbar(
        MESSAGES.COMMON.NO_CHANGES_TO_SAVE,
        { variant: "info" }
      );
    }
   }

  onCloseSetAPTWindow = (confirm) => {
    if (!confirm) {
      this.clearSetAPTWindow();
      return;
    }
    this.updateSelectedProAPTWindow(this.state.setAPTWindowPros);
  };

  clearSetAPTWindow = () => {
    this.setState({
      setAPTWindowPros: [],
      setProAPTInProgress: false,
    });
  };

  getProNumbersStringFromProData=(setAPTWindowPros)=>{
    return setAPTWindowPros.map(pro=>pro.proId).join(" , ")
  }
  
   updateSelectedProAPTWindow = (shipments) => {
    this.setState({
      setProAPTInProgress:true
    })
     const pros = shipments.map((pro) => {
       const shipmentCTA = this.getUpdatedShipmentCTA(pro.deliveryDateTime);
       return { proId: pro.proId, shipmentCTA };
     });
     const requestParams = {
      pros,
      scenarioId : this.props.userData.userProfile.scenarioID
     }
     const updateAPI = this.getUpdateAPI();
     postData(updateAPI, requestParams).then(
       (response) => {
         if (response && Math.trunc(response.status / 100) === 2) {
           this.props.enqueueSnackbar(`APT window updated`, {
             variant: "success",
           });

           this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
             false,
             this.isRoutesView
               ? this.props.IBPlanningStore.selectedRouteNameList
               : null,
             this.gridApi.getSelectedRows().map((shipment) => shipment.proId),
           ]);
           this.clearSetAPTWindow();
         } else {
          this.handleSetAPTWindowFailure();
         }
       },
       (_error) => {
         this.handleSetAPTWindowFailure();
       }
     );
  }

  handleSetAPTWindowFailure = () => {
    this.props.enqueueSnackbar(`Failed to set APT window`, {
      variant: "error",
    });
    this.clearSetAPTWindow();
  }

  getUpdatedShipmentCTA = (deliveryDateTime) => {
    const { format : yearDateTimeFormat } = appConstant.DATETYPES.YEARDATETIME;
    const startTime = format(subMinutes(new Date(deliveryDateTime), appConstant.APPOINTMENT_WINDOW_MINUTES), yearDateTimeFormat);
    const endTime = format(
      addMinutes(new Date(deliveryDateTime), appConstant.APPOINTMENT_WINDOW_MINUTES),
      yearDateTimeFormat
    );
    return `${startTime} - ${endTime}`;
  }

  refreshViolationColumn = () => {
    if (this.gridApi.refreshCells) {
      this.gridApi.refreshCells({ columns: ["violation"], force: true });
    }
    if (this.state.filterData && this.gridApi.onFilterChanged) {
      this.gridApi.onFilterChanged();
    }
  };

  geocodeSelectedShipments = () => {
    const selectedShipments = this.gridApi.getSelectedRows();
    if (!selectedShipments.length) {
      return;
    }

    this.setState({
      geocodeShipment: {
        ...getShipmentCustomerData(selectedShipments[0]),
        proId: selectedShipments[0].proId,
      },
    });

    //Log Telemetry
    const userProfile = this.props.userData.userProfile;
    const eventSpecificData = {
      shipments: selectedShipments[0].proId,
    };
    trackEvent("Geocode", userProfile, eventSpecificData);
  };

  closeGeocodeModal = (hasDataChanged = false) => {
    if (hasDataChanged) {
      this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
        false,
        this.isRoutesView
          ? this.props.IBPlanningStore.selectedRouteNameList
          : null,
        [this.state.geocodeShipment.proId],
      ]);
    }
    this.setState({
      geocodeShipment: null,
    });
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      quickFilterText: searchText,
    });
  };
  selectShipments = (shipmentList, ensureIndexVisible = true) => {
    if (this.gridApi && this.gridApi.forEachNode) {
      this.gridApi.forEachNode((node) => {
        if (shipmentList.includes(node.data.proId)) {
          node.setSelected(true, false, true);
          if (ensureIndexVisible) {
            this.gridApi.ensureIndexVisible(node.rowIndex);
          }
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };
  onShipmentSelectedOnMap = (proId) => {
    if (this.gridApi) {
      const selectedNode = this.gridApi
        .getSelectedNodes()
        .find((node) => node.data.proId === proId);
      if (selectedNode) {
        // if prodId is already selected move it back into the view
        this.gridApi.ensureIndexVisible(selectedNode.rowIndex);
      }
    }
  };
  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.selectShipments(this.props.IBPlanningStore.selectedShipmentIDList);
    this.gridApi.runCommand = this.runCommand;
  };

  onSelectionChanged = (event) => {
    if (this.gridApi) {
      this.selectedShipmentProIdList = this.gridApi
        .getSelectedRows()
        .map((shipment) => shipment.proId);
      if (
        !isEqual(
          this.selectedShipmentProIdList,
          this.props.IBPlanningStore.selectedShipmentIDList
        )
      ) {
        // this.props.IBPlanningStore.updateSelectedShipments(this.selectedShipmentProIdList);
        this.props.glEventHub.emit("UpdateIBStore", "updateSelectedShipments", [
          this.selectedShipmentProIdList,
        ]);
      }
    }
  };

  onCellValueChanged = (params) => {
    const proIdList = [params.data.proId];
    const field = params.colDef.field;
    let value = params.value;
    if (field === "groupId" && [undefined, ""].includes(value)) {
      value = null;
    }
    if (this.isUpdateValid({ proIdList, field, value, currentCell: params })) {
      // For inline edit we are backing up data here because we wont get previous value from anywhere else
      this.shipmentBackupData = {};
      this.shipmentBackupData[params.data.proId] = {
        [field]: params.oldValue,
      };
      if (field === "routeName") {
        params.data[field] =
          params.value && params.value.label ? params.value.label : null;
        this.getTrapInfoAndUpdateShipment({ proIdList, field, value });
      } else {
        this.updateShipmentInfo({ proIdList, field, value });
      }
    } else {
      params.data[field] = params.oldValue;
      this.gridApi.refreshCells({ columns: [field], force: true });
    }
  };

  getSelectedEditableShipments = (field) => {
    const columnDef = this.gridApi.getColumnDef(field);
    if (columnDef && typeof columnDef.editable === "function") {
      return this.gridApi
        .getSelectedNodes()
        .filter((node) => columnDef.editable(node))
        .map((node) => node.data);
    }
    return this.gridApi.getSelectedRows();
  };

  onBulkUpdate = ({ field, newValue }) => {
    let proIdList = this.getSelectedEditableShipments(field).map(
      (shipment) => shipment.proId
    );
    if (field === "routeName") {
      proIdList = this.gridApi
        .getSelectedRows()
        .filter((shipment) => shipment.isInPlan)
        .map((shipment) => shipment.proId);
    }
    if (field === "isFlexiApt") {
      newValue = newValue.value;
    }
    if (field === "groupId" && [undefined, ""].includes(newValue)) {
      newValue = null;
    }
    let currentCell = null;
    if (proIdList.length === 1) {
      currentCell = {
        oldValue: this.gridApi.getSelectedRows()[0][field],
      };
    }
    if (
      this.isUpdateValid({
        proIdList,
        field,
        value: newValue,
        currentCell,
        isBulkEdit: true,
      })
    ) {
      this.updateShipmentUI({ proIdList, field, value: newValue });
      if (field === "routeName") {
        this.getTrapInfoAndUpdateShipment({
          proIdList,
          field,
          value: newValue,
        });
      } else {
        this.updateShipmentInfo({ proIdList, field, value: newValue });
      }
    }
  };

  isUpdateValid = ({ proIdList, field, value, currentCell, isBulkEdit }) => {
    if (proIdList.length === 0) {
      if (field === "shipmentEtaDateTime") {
        this.props.enqueueSnackbar(
          MESSAGES.SHIPMENT_UPDATE.NO_NON_ARRIVED_SHIPMENT_SELECTED,
          { variant: "error" }
        );
      } else if (field === "routeName") {
        this.props.enqueueSnackbar(
          MESSAGES.SHIPMENT_UPDATE.NO_INPLAN_SHIPMENT_SELECTED,
          { variant: "error" }
        );
      } else {
        this.props.enqueueSnackbar(
          MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED,
          { variant: "error" }
        );
      }
      return false;
    }
    let isUpdateValid = true;
    switch (field) {
      case "routeName":
        // if route didnt change or we reassigned null the update is invalid
        if (!value) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.ROUTE_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (
          currentCell &&
          (currentCell.oldValue === value ||
            (value && currentCell.oldValue === value.label))
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "liftgate":
        if (
          currentCell &&
          (Boolean(currentCell.oldValue) === Boolean(value) ||
            (value && currentCell.oldValue === value.value))
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "shipmentEtaDateTime":
        // Show empty error message on single edit when old value was not null and always on bulk edit
        if (
          (currentCell && currentCell.oldValue && !value) ||
          (!currentCell && !value)
        ) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.IBETA_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        }
        if (value && !isDateTimeValid(value)) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.IBETA_INVALID, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "weight":
      case "hu":
        if (value === "") {
          const fieldName = field === "weight" ? "Weight" : "HU";
          this.props.enqueueSnackbar(
            `Cannot assign empty value to ${fieldName}`,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (
          currentCell &&
          Number(currentCell.oldValue) === Number(value)
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "pse":
        if (value === "") {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PSE_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (value === 0) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PSE_ZEROVALUE, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (
          currentCell &&
          Number(currentCell.oldValue) === Number(value)
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "freezerPlts":
         if (currentCell && Number(currentCell.oldValue) === Number(value)) {
           isBulkEdit &&
             this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
               variant: "info",
             });
           isUpdateValid = false;
         }
         break;
     case "coolerPlts":
         if (currentCell && Number(currentCell.oldValue) === Number(value)) {
           isBulkEdit &&
             this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
               variant: "info",
             });
           isUpdateValid = false;
         }
         break;
      case "preparationTime":
        if (value === "") {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PREPTIME_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (isNaN(value)) {
          this.props.enqueueSnackbar(
            MESSAGES.SHIPMENT_UPDATE.PREPTIME_INVALID,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "shipmentCTA":
        const canAcceptNull = this.gridApi.getColumnDef("shipmentCTA")?.cellEditorParams?.canAcceptNull;
        if (!canAcceptNull && !value) {
          this.props.enqueueSnackbar(
            MESSAGES.SHIPMENT_UPDATE.EARLY_LATE_CTA_EMPTY,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (value!== null && value?.split(" - ").length != 2) {
          this.props.enqueueSnackbar(
            MESSAGES.SHIPMENT_UPDATE.EARLY_LATE_CTA_INVALID,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "maxFeasibleTrailerLength":
        if (currentCell && (currentCell.oldValue === value || parseInt(currentCell.oldValue) === parseInt(value?.label))) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "isFlexiApt":
        if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
         break;
      case "groupId":
        if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
         break;
      default:
        if (currentCell && currentCell.oldValue === value) {
          (isBulkEdit || field==="shipmentComments") &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
    }
    return isUpdateValid;
  };

  // Updates the UI (which in turn will updated the store) to display updated values & creates a backup of existing values for restore on failure
  updateShipmentUI = ({ proIdList, field, value }) => {
    this.shipmentBackupData = {};
    if (field === "routeName") {
      value = value.label || value;
    }
    this.gridApi.getSelectedRows().map((shipment) => {
      if (proIdList.includes(shipment.proId)) {
        this.shipmentBackupData[shipment.proId] = {
          [field]: shipment[field],
        };
        shipment[field] = value;
      }
    });
    this.gridApi.refreshCells();
  };

  // Updates the UI(which in turn will updated the store) to the value available from backup
  restoreShipmentData = ({ proIdList, field }) => {
    this.gridApi.forEachNode((node) => {
      if (proIdList.includes(node.data.proId)) {
        node.data[field] = this.shipmentBackupData[node.data.proId][field];
      }
    });
    this.selectShipments(proIdList, true);
    this.gridApi.refreshCells();
  };

  getRequestParams = ({ proIdList, field, value }) => {
    let requestParams = {
      scenarioId: this.props.userData.userProfile.scenarioID,
    };
    if (field === "routeName") {
      requestParams.routeName = value ? value.label : null;
      requestParams.isTrapRoute = value ? value.isTrapRoute : null;
      requestParams.pros = proIdList;
    } else if (field === "liftgate") {
      requestParams.pros = proIdList.map((proId) => ({
        proId,
        [field]: value ? Boolean(value.value) : false,
      }));
    } else if (field === "maxFeasibleTrailerLength") {
      requestParams.customers = this.getSelectedEditableShipments()?.map((shipment) => ({
        customerId: shipment.customerId,
        maxFeasibleTrailerLength: value? parseInt(value.label): null,
      }));
    } else if (field === "isFlexiApt") {
      requestParams.pros = proIdList.map((proId) => ({
        proId,
        [field]: value || false,
      }));
    }else {
      requestParams.pros = proIdList.map((proId) => ({
        proId,
        [field]: value,
      }));
    }
    return requestParams;
  };

  getTrapInfoAndUpdateShipment = ({ proIdList, field, value }) => {
    if (value && value.isNewValue) {
      this.updateObject = { proIdList, field, value };
      this.showRouteConfirmationModal();
      return;
    } else if (
      value &&
      !value.isNewValue &&
      this.props.IBPlanningStore.routesList
    ) {
      const route = this.props.IBPlanningStore.routesList.find(
        (r) => r.routeId === value.value
      );
      if (route) {
        value.isTrapRoute =
          route.routeName === "UNRTD" ? true : route.isTrapRoute;
      }
    }
    this.updateShipmentInfo({ proIdList, field, value });
  };

  getUpdateAPI = (field) => {
    switch (field) {
      case "routeName":
        return "UpdateShipmentRouteAssignment";
      case "maxFeasibleTrailerLength":
        return "UpdateCustomerTrailerLengthPreference";
      default:
        return "UpdateShipmentsProperty";
    }
  };

  updateShipmentInfo = ({ proIdList, field, value }) => {
      
    const requestParams = this.getRequestParams({ proIdList, field, value });
    this.props.glEventHub.emit(`${this.gridHeaderId}_DisableEditSave`, true);
    const { headerTooltip } = this.gridApi.getColumnDef(field);
    const updateAPI = this.getUpdateAPI(field);
    postData(updateAPI, requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(`${headerTooltip} updated`, {
            variant: "success",
          });
          this.props.glEventHub.emit(
            `${this.gridHeaderId}_showEditMode`,
            false
          );
          this.shipmentRevertFieldsUpdated = Object.values(REVERT_COLUMNS).includes(field); 
          this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
            false,
            this.isRoutesView
              ? this.props.IBPlanningStore.selectedRouteNameList
              : null,
            this.gridApi.getSelectedRows().map((shipment) => shipment.proId),
          ]);
          if (field === 'shipmentComments') {
            this.updateModalVisibility({shipmentNoteDialogParams: null});
          }
        } else {
          this.restoreShipmentData({ proIdList, field });
          this.props.enqueueSnackbar(`Failed to update ${headerTooltip}`, {
            variant: "error",
          });
        }
        this.props.glEventHub.emit(
          `${this.gridHeaderId}_DisableEditSave`,
          false
        );
      },
      (error) => {
        this.restoreShipmentData({ proIdList, field });
        this.props.glEventHub.emit(
          `${this.gridHeaderId}_DisableEditSave`,
          false
        );
        this.props.enqueueSnackbar(`Failed to update ${headerTooltip}`, {
          variant: "error",
        });
      }
    );

    //Log Telemetry
    const userProfile = this.props.userData.userProfile;
    if (field === "routeName") {
      const eventSpecificData = {
        route: requestParams.routeName,
      };
      trackEvent("RouteUpdateShipmentsGrid", userProfile, eventSpecificData);
    } else if (field === "maxFeasibleTrailerLength") {
      trackEvent("UpdateCustomerTrailerLength", userProfile, requestParams);
    } else {
      const eventSpecificData = {
        pros: requestParams.pros.map((pro) => pro.proId),
      };
      trackEvent("ShipmentMetadataUpdate", userProfile, eventSpecificData);
    }
  };

  showRouteConfirmationModal = () => {
    this.setState({
      isRouteConfirmModalVisible: true,
    });
  };

  closeRouteConfirmationModal = () => {
    this.setState({
      isRouteConfirmModalVisible: false,
    });
    const { proIdList, field } = this.updateObject;
    this.restoreShipmentData({ proIdList, field });
  };

  confirmRouteType = (routeType) => {
    this.setState({
      isRouteConfirmModalVisible: false,
    });
    this.updateObject.value.isTrapRoute = routeType === "Trap";
    this.updateShipmentInfo({ ...this.updateObject });
    delete this.updateObject;
  };

  onFilterChanged = () => {
    let filteredProList = [];
    this.gridApi.forEachNodeAfterFilter((node) =>
      filteredProList.push(node.data.proId)
    );
  };

  updateModalVisibility = ({showProImagesPopup, shipmentNoteDialogParams}) => {
    this.setState({
      showProImagesPopup,
      shipmentNoteDialogParams,
    });
  };

  onCellClicked = (params) => {
    const proIdList = this.gridApi
      .getSelectedRows()
      .map((shipment) => shipment.proId);
    this.setState({ proIdList });
    if (
      this.state.proIdList.length === 1 &&
      this.hasProImagesURL() &&
      params.column.colId === "proId"
    ) {
      this.updateModalVisibility({ showProImagesPopup: true });
    }
  };

  doesExternalFilterPass = (node) => {
    switch (this.state.filterData) {
      case "LateShipments":
        return Boolean(
          CheckViolation.checkRouteStartTimeViolation({
            data: node.data,
            planDate: this.props.userData.userProfile.planDate,
          })
        );
      case "NewPros":
        return Boolean(
          CheckViolation.checkProIsNew({
            data: node.data,
            context: this.gridContext,
          })
        );
      default:
        return true;
    }
  };

  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      () => this.gridApi.onFilterChanged()
    );
  };

  constructStatusBar = (shipmentsList) => {
    const delayedShipmentsCount = shipmentsList
      ? shipmentsList
          .map((shipments) =>
            Boolean(
              CheckViolation.checkRouteStartTimeViolation({
                data: shipments,
                planDate: this.props.userData.userProfile.planDate,
              })
            )
          )
          .filter((value) => value).length
      : 0;
    const newProsCount = shipmentsList
      ? shipmentsList
          .map((shipments) =>
            Boolean(
              CheckViolation.checkProIsNew({
                data: shipments,
                context: this.gridContext,
              })
            )
          )
          .filter((value) => value).length
      : 0;
    return this.isRoutesView
      ? [
          {
            label: shipmentsList.length + " Shipments",
            filterCondition: "",
          },
          {
            label: newProsCount + " New",
            filterCondition: "NewPros",
          },
          {
            label: delayedShipmentsCount + " Arriving Late",
            filterCondition: "LateShipments",
          },
        ]
      : [
          {
            label: shipmentsList.length + " Shipments",
          },
        ];
  };

  onModelUpdated = ({ filterManager }) => {
    const { advancedFilterPresent, quickFilter } = filterManager;

    //advancedFilterPresent is boolean value and is set to true when column filter is applied
    //quickFilter(similar to quickFilterText) is string value and is set when something is searched in searchbar
    //this.props.IBPlanningStore.quickFilter is set when we apply quick filter
    if (
      advancedFilterPresent ||
      quickFilter ||
      this.props.IBPlanningStore.quickFilter
    ) {
      this.isAnyFilterSet = true;
      //this.props.IBPlanningStore.updateFilteredShipments(this.gridApi.rowModel.rowsToDisplay.map(shipment=>shipment.data));
      this.props.glEventHub.emit("UpdateIBStore", "updateFilteredShipments", [
        this.gridApi.rowModel.rowsToDisplay.map((shipment) => shipment.data),
      ]);
    } else {
      if (this.isAnyFilterSet) {
        this.props.glEventHub.emit("UpdateIBStore", "updateFilteredShipments", [
          this.props.IBPlanningStore.shipmentsList,
        ]);
        //this.props.IBPlanningStore.updateFilteredShipments(this.props.IBPlanningStore.shipmentsList);
        this.isAnyFilterSet = false;
      }
    }
  };

  onRowDataUpdated = () => {
    if (this.datarefreshed) {
      this.selectShipments(
        this.props.IBPlanningStore.selectedShipmentIDList,
        false
      );
    }
    if(this.shipmentRevertFieldsUpdated){
      // Rerender fields with revert action after data load to render updated & revert icons 
      this.gridApi.refreshCells({
        columns: Object.values(REVERT_COLUMNS),
        force: true
      });
      this.shipmentRevertFieldsUpdated = false;
    }
    this.datarefreshed = false;
  };

  onDoubleClicked = (params) => {
    if (["consigneeName", "consigneeCode"].includes(params.column.colId)) {
      const { code, type } = params?.node?.data.isDelivery
        ? { code: params?.node?.data.customerCode, type: appConstant.CUSTOMER_TYPE.DELIVERY }
        : { code: params?.node?.data.shipperCode, type: appConstant.CUSTOMER_TYPE.PICKUP };
      Events.emit("OpenEditCustomerDialog", code, type);
    } else if (params.column.colId === "shipmentComments") {
      this.onClickShipmentNote(params);
    }
  };

  onCloseRevertColumn = (confirm) =>{
    if(!confirm){
       this.clearRevertColumn();
      return;
    }
    this.revertAPTWindowForPros(this.state.revertPros)
  }

  clearRevertColumn = () =>{
    this.revertField = null;
    this.setState({
      revertPros:[],
      revertProInProgress: false
    })
  }

  revertAPTWindowForPros = (proIdList) => {
    const fieldConfig=REVERT_COLUMN_CONFIG[this.revertField];
    const field =fieldConfig.revertField;
    const requestParams = this.getRequestParams({ proIdList, field, value:true });
    const updateAPI = this.getUpdateAPI(field);
    this.setState({
      revertProInProgress: true
    })
    postData(updateAPI, requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(fieldConfig.revertSuccessMessage, {
            variant: "success",
          });

          this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
            false,
            this.isRoutesView
              ? this.props.IBPlanningStore.selectedRouteNameList
              : null,
            this.gridApi.getSelectedRows().map((shipment) => shipment.proId),
          ]);
          this.clearRevertColumn();
        } else {
          this.handleReverAPTFailure();
        }
      },
      (error) => {
       this.handleReverAPTFailure();
      }
    );
  }

  handleReverAPTFailure = () => {
    this.props.enqueueSnackbar(REVERT_COLUMN_CONFIG[this.revertField].revertErrorMessage, {
      variant: "error",
    });
    this.clearRevertColumn();
  }

  onClickShipmentNote = (params) => {
    if (params.isBulkEdit) {
      const selectedPros = this.gridApi.getSelectedRows();
      this.updateModalVisibility({ shipmentNoteDialogParams: {data: selectedPros, isBulkEdit: params.isBulkEdit} });
      return;
    }
    this.updateModalVisibility({
      shipmentNoteDialogParams: {
        ...params,
        isBulkEdit: Boolean(params.isBulkEdit),
      },
    });
  };

  handleShipmentNoteSubmit = (props) => {
    if (props.isBulkEdit) {
      this.onBulkUpdate({ field: 'shipmentComments', newValue: props.value });
      return;
    }
    this.onCellValueChanged(props);
  }

  getProNoteTitleDetails = () => {
    const { data, isBulkEdit } = this.state.shipmentNoteDialogParams;
    const getCustomerDetails = (pro) => {
      const name = pro.isDelivery ? pro.consigneeName : pro.shipperName;
      const code = pro.isDelivery ? pro.consigneeCode : pro.shipperCode;
      return `${name || ""} (#${code})`;
    };
    const getCustomerType = (shipment) => {
      return shipment.isDelivery ? "Customer" : "Shipper";
    };
    if (isBulkEdit) {
      return data.map((pro) => ({
        proNumber: pro.proId,
        customerDetail: getCustomerDetails(pro),
        type: getCustomerType(pro),
      }));
    }
    return [
      {
        proNumber: data.proId,
        customerDetail: getCustomerDetails(data),
        type: getCustomerType(data),
      },
    ];
  }
  
  render() {
    let shipmentsList = [];
    this.selectedShipmentProIdList = [];
    if (this.isRoutesView) {
      shipmentsList =
        this.props.IBPlanningStore.filteredRouteShipments.length > 0
          ? this.props.IBPlanningStore.filteredRouteShipments.slice()
          : "";
    } else {
      shipmentsList =
        this.props.IBPlanningStore.filteredShipments.length > 0
          ? this.props.IBPlanningStore.filteredShipments.slice()
          : "";
    }
    return (
      <Fragment>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={shipmentsList}
          onSelectionChanged={this.onSelectionChanged}
          onGridReady={this.onGridReady}
          panelLabel={(filteredData) => (
            <StatusBar
              data={this.constructStatusBar(filteredData)}
              filterGridData={this.updateGridData}
            />
          )}
          onCellValueChanged={this.onCellValueChanged}
          quickFilterText={this.state.quickFilterText}
          layoutContainer={this.props.glContainer}
          onFilterChanged={this.onFilterChanged}
          onCellClicked={this.onCellClicked}
          deltaRowDataMode={true}
          getRowNodeId={(data) => data.proId}
          onRowDataUpdated={this.onRowDataUpdated}
          accentedSort={true}
          isExternalFilterPresent={() => Boolean(this.state.filterData)}
          doesExternalFilterPass={this.doesExternalFilterPass}
          onModelUpdated={this.onModelUpdated}
          context={this.gridContext}
          onCellDoubleClicked={this.onDoubleClicked}
        />
        {this.state.isRouteConfirmModalVisible && (
          <RouteConfirmationModal
            routeName={`${this.updateObject ? this.updateObject.value.label : ''}`}
            close={this.closeRouteConfirmationModal}
            confirm={this.confirmRouteType}
          />
        )}
        <Suspense fallback={<AppLoading />}>
          {this.state.showProImagesPopup && (
            <ViewProImages
              proNumber={this.state.proIdList[0]}
              show={this.state.showProImagesPopup}
              onClose={() => {
                this.updateModalVisibility({showProImagesPopup: false});
              }}
            />
          )}
        </Suspense>
        {this.state.geocodeShipment && (
          <GeocodingModal
            customer={this.state.geocodeShipment}
            userData={this.props.userData.userProfile}
            close={this.closeGeocodeModal}
          />
        )}
        {this.state.revertPros.length > 0 && (
          <Dialog
            key={'revertColumnData'}
            title={REVERT_COLUMN_CONFIG[this.revertField].confirmDialogProps.title}
            discardLabel="Cancel"
            confirmLabel="Confirm"
            onClose={this.onCloseRevertColumn}
            buttonProps={{ disabled: this.state.revertProInProgress }}
            isProcessing={this.state.revertProInProgress}>
            <div> {REVERT_COLUMN_CONFIG[this.revertField].confirmDialogProps.contentText}</div>
            <div> {this.state.revertPros.join(' , ')}</div>
          </Dialog>
        )}
        {/* {this.state.revertFrozenPros.length > 0 && (
          <Dialog
            key={'revertFrozenPlts'}
            title={REVERT_COLUMN_CONFIG[this.revertField].confirmDialogProps.contentText}
            discardLabel="Cancel"
            confirmLabel="Confirm"
            onClose={this.onCloseRevertFrozenPallets}
            buttonProps={{ disabled: this.state.revertProInProgress }}
            isProcessing={this.state.revertProInProgress}>
            <div> {REVERT_COLUMN_CONFIG[this.revertField].confirmDialogProps.contentText}</div>
            <div> {this.state.revertPros.join(' , ')}</div>
          </Dialog>
        )} */}
        {this.state.setAPTWindowPros.length > 0 && (
          <Dialog
            key={'setAPTWindow'}
            title="Confirm Set APT window based on Service DateTime"
            discardLabel="Cancel"
            confirmLabel="Confirm"
            onClose={this.onCloseSetAPTWindow}
            buttonProps={{ disabled: this.state.setProAPTInProgress }}
            isProcessing={this.state.setProAPTInProgress}>
            <div>Set APT window based on Service DateTime for the below Pros</div>
            <div>{this.getProNumbersStringFromProData(this.state.setAPTWindowPros)}</div>
          </Dialog>
        )}
        {this.state.shipmentNoteDialogParams && (
          <Suspense fallback={<AppLoading />}>
            <ShipmentNote
              handleClose={() => this.updateModalVisibility({shipmentNoteDialogParams: null})}
              handleSubmit={this.handleShipmentNoteSubmit}
              params={this.state.shipmentNoteDialogParams}
              userProfile={this.props.userData.userProfile}
              customerList={this.getProNoteTitleDetails()}
            />
          </Suspense>
        )}
      </Fragment>
    );
  }
}

export default compose(
  withStyles(styles),
  withAppConfig,
  withUserProfile,
  withSnackbar,
  withFeatureFlags
)(ShipmentsGrid);
